// extracted by mini-css-extract-plugin
module.exports = {"input":"PhoneInput-module--input--_nLN_","widgetContainer":"PhoneInput-module--widgetContainer--1sbEy","flag":"PhoneInput-module--flag--23Ind"};